import * as React from "react";
import { SectionHeader } from "../SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { GenderOptions, Marital, GenderOptionsMap } from "../../Resource/Contents";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { Gender } from "../../../../../../../Wrap/Constants/Enums/Domain/Gender";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import {
    Alphabetical2,
    Numeric2,
    NonePureAlphabetical,
} from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { ValidatorContents } from "../../../../../Common/ValidatorHelper";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { TaxReferenceType } from "../../../../../../../Wrap/Constants/Enums/Customer/TaxReferenceType";
import { EWizardLinterHelper } from "../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { ACCEPT_DATE_FORMATS, ContentDatePicker } from "../../../../../../Shared/Entities/Constants/DateConstants";
import { validationMessage } from "../../../AddClient/Resource/Validation";
import { Title } from "../../../../../../../Wrap/Constants/Enums/Title";
import { UserStore } from "../../../../../Stroes/Variable";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";

interface IGuardianDetailProps extends IProcessComponentProps {
    onCCMChange: (changes) => void;
    data: FullClientDetailModel;
    disableWhenFullClient: boolean;
    isAddNewProduct?: boolean;
    existingClientInfo?: FullClientDetailModel;
    index: number;
}

interface IGuardianDetailState {
    NationalNumber: string[];
    useUniversalNINO: boolean;
    disableClientDetails: boolean;
    disableMaritalStatus: boolean;
    userInfo: User;
}

export class GuardianDetail extends ProcessComponent<IGuardianDetailProps, IGuardianDetailState> {
    constructor(props: IGuardianDetailProps) {
        super(props);
        this.state = {
            NationalNumber: [null, null, null, null, null],
            useUniversalNINO: false,
            disableClientDetails: false,
            disableMaritalStatus: false,
            userInfo: UserStore.getUserInfo(),
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.updateNationalNumberDisplay();
        this.checkDisableStatus();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (prevProps.data?.ActorId !== this.props.data?.ActorId) {
            this.updateNationalNumberDisplay();

            if (this.props.disableWhenFullClient == true) {
                this.checkDisableStatus();
            }
        }
    }

    private checkDisableStatus() {
        if (this.props.disableWhenFullClient) {
            const disableClient =
                this.getBlockClientDetailsStatus(this.props.existingClientInfo) == EWizardLinterStatus.PleaseCheck;
            const disableMarital =
                this.getBlockMaritalStatus(this.props.existingClientInfo) == EWizardLinterStatus.PleaseCheck;
            this.setState({ disableClientDetails: disableClient, disableMaritalStatus: disableMarital });
        }
        if (this.props.isAddNewProduct) {
            this.setState({
                disableClientDetails: true,
                disableMaritalStatus: true,
            });
        }
    }

    updateNationalNumberDisplay() {
        const { NationalNumber } = this.state;
        const _data =
            this.props.data.CustomerTaxResidencyDetails?.find((ele) => ele.TaxReferenceType == TaxReferenceType.GbrNino)
                ?.TaxReference || "";
        for (let i = 0; i < NationalNumber.length; i++) {
            NationalNumber[i] = _data.substr(i * 2, 2);
        }
        this.setState({ NationalNumber });
    }

    onNationalNumberChanges(index, value: string) {
        const _nationalNum = this.state.NationalNumber.concat();
        _nationalNum[index] = value;
        let result = "";
        _nationalNum.forEach((ele) => {
            if (!ele) {ele = "";}
            result += ele;
        });
        this.setState({ NationalNumber: _nationalNum });
        this.props.onCCMChange([
            {
                value: result,
                path: `CustomerTaxResidencyDetails.0.TaxReference`,
            },
            {
                value: TaxReferenceType.GbrNino,
                path: `CustomerTaxResidencyDetails.0.TaxReferenceType`,
            },
            {
                value: true,
                path: `CustomerTaxResidencyDetails.0.IsTaxResident`,
            },
        ]);
    }

    getBlockClientDetailsStatus(model: FullClientDetailModel): EWizardLinterStatus {
        const data = model?.PersonalDetails;
        const complete =
            data &&
            data.Title != null &&
            data.GivenName != null &&
            data.FamilyName != null &&
            data.DateOfBirth != null &&
            data.Gender != null;
        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    getBlockMaritalStatus(model: FullClientDetailModel): EWizardLinterStatus {
        const data = model?.PersonalDetails;
        const { NationalNumber } = this.state;
        const complete =
            data &&
            data.MaritalStatus != null &&
            data.MaritalStatus != 0 &&
            !NationalNumber.includes(null) &&
            !NationalNumber.includes("");
        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    moveToNextInput(cur: number, value: string) {
        if (value.length == 2) {
            const next = cur + 1;
            const nextInput = document.getElementById(`national-insurance-number-${this.props.index}-${next}`);
            nextInput.focus();
        }
    }

    render() {
        const { data } = this.props;
        const { NationalNumber, disableClientDetails, disableMaritalStatus } = this.state;
        return (
            <>
                {SectionHeader("Guardians details")}
                <WizardLinter status={this.getBlockClientDetailsStatus(data)} enabled={true}>
                    {disableClientDetails && (
                        <>
                            <TextBoxEditor
                                value={TitleMap.getString(data.PersonalDetails?.Title)}
                                disabled={true}
                                label="Title"
                                cssWrapper="control-size-430"
                                onChange={(v) => {
                                    this.props.onCCMChange([{ value: v, path: "PersonalDetails.Title" }]);
                                }}
                            />

                            <TextBoxEditor
                                cssWrapper="control-size-430"
                                value={`${data.PersonalDetails?.GivenName} ${data.PersonalDetails?.FamilyName}`}
                                disabled={true}
                                label={"Client name"}
                                onChange={(v) => {
                                    this.props.onCCMChange([{ value: v, path: "PersonalDetails.FamilyName" }]);
                                }}
                            />
                        </>
                    )}
                    {!disableClientDetails && (
                        <>
                            <SelectEditor
                                options={TitleMap.getArray()}
                                cssWrapper="control-size-180"
                                selected={data ? data.PersonalDetails?.Title : Title.Mr}
                                label={"Title"}
                                getText={(option) => TitleMap.getString(option)}
                                onChange={(v) => this.props.onCCMChange([{ value: v, path: "PersonalDetails.Title" }])}
                                required={validationMessage.titleValidation}
                            />
                            <TextBoxEditor
                                cssWrapper="control-size-430"
                                value={data.PersonalDetails?.GivenName}
                                label={"First name"}
                                regex={{
                                    errorMessage: "First name should not be all numbers",
                                    value: NonePureAlphabetical,
                                }}
                                onChange={(v) =>
                                    this.props.onCCMChange([{ value: v, path: "PersonalDetails.GivenName" }])
                                }
                                required={validationMessage.firstNameValidation}
                            />
                            <TextBoxEditor
                                cssWrapper="control-size-430"
                                value={data.PersonalDetails?.FamilyName}
                                label={"Surname"}
                                onChange={(v) =>
                                    this.props.onCCMChange([{ value: v, path: "PersonalDetails.FamilyName" }])
                                }
                                regex={{
                                    errorMessage: "Surname should not be all numbers",
                                    value: NonePureAlphabetical,
                                }}
                                required={validationMessage.surnameValidation}
                            />
                        </>
                    )}

                    {disableClientDetails && (
                        <fieldset className="form-group control-size-430">
                            <legend className="control-label">Date of birth (dd/mm/yyyy)</legend>
                            <div className="controls-wrap">
                                <div className="row narrow-gutter">
                                    <div className="col-3">
                                        <TextBoxEditor
                                            cssWrapper="mb-0"
                                            value={data.PersonalDetails && data.PersonalDetails.DateOfBirth ? `${JsonDateParser.toDate(
                                                data.PersonalDetails?.DateOfBirth
                                            ).getDate()}` : null}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <TextBoxEditor
                                            cssWrapper="mb-0"
                                            value={data.PersonalDetails && data.PersonalDetails.DateOfBirth ? `${JsonDateParser.getMonthNameMapping(
                                                JsonDateParser.toDate(data.PersonalDetails?.DateOfBirth).getMonth() + 1
                                            )}` : null}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col-3">
                                        <TextBoxEditor
                                            cssWrapper="mb-0"
                                            value={data.PersonalDetails && data.PersonalDetails.DateOfBirth ? `${JsonDateParser.toDate(
                                                data.PersonalDetails?.DateOfBirth
                                            ).getFullYear()}` : null}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                    {!disableClientDetails && (
                        <DatePicker
                            label={"Date of birth"}
                            formGroupCssWrapper={"control-size-430"}
                            selected={JsonDateParser.toDateNoOffset(data?.PersonalDetails?.DateOfBirth)}
                            alwaysValidateOnUpdate={false}
                            atLeast={{
                                value: new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
                                errorMessage: ContentDatePicker.CannotBeInThePast,
                            }}
                            atMost={{
                                value: new Date(),
                                errorMessage: ContentDatePicker.CannotBeInTheFuture,
                            }}
                            showYearDropdown={true}
                            onChange={(v) => {
                                this.props.onCCMChange([
                                    {
                                        value: JsonDateParser.toJsonDateNoOffset(v),
                                        path: "PersonalDetails.DateOfBirth",
                                    },
                                ]);
                            }}
                            todayButton={ContentDatePicker.Today}
                            isClearable={true}
                            dateFormat={ContentDatePicker.DateFormat}
                            acceptDateFormats={ACCEPT_DATE_FORMATS}
                        />
                    )}
                    <RadiosEditor
                        cssWrapper="rg-inline mb-16"
                        label="Gender"
                        options={GenderOptions}
                        getText={(v) => {
                            return GenderOptionsMap[v];
                        }}
                        onChange={(v) => {
                            this.props.onCCMChange([{ value: v, path: "PersonalDetails.Gender" }]);
                        }}
                        disabled={disableClientDetails}
                        selected={
                            data.PersonalDetails?.Gender == Gender.Female
                                ? GenderOptions[1]
                                : data.PersonalDetails?.Gender == Gender.Male
                                ? GenderOptions[0]
                                : null
                        }
                    />
                </WizardLinter>
                <WizardLinter status={this.getBlockMaritalStatus(this.props.data)} enabled={true}>
                    <SelectEditor
                        placeholder={"Please select"}
                        cssWrapper="control-size-430"
                        getText={(v) => {
                            return Marital.optionsMap[v];
                        }}
                        options={Marital.options}
                        label={Marital.title}
                        onChange={(v) => {
                            this.props.onCCMChange([{ value: v, path: "PersonalDetails.MaritalStatus" }]);
                        }}
                        required={"Please select " + Marital.title}
                        selected={data.PersonalDetails?.MaritalStatus}
                        disabled={disableMaritalStatus}
                    />
                    <fieldset>
                        <legend className="control-label">National Insurance Number</legend>
                        <div className="row narrow-gutter">
                            <div className="col-auto">
                                <TextBoxEditor
                                    cssWrapper="control-size-60 label-sr-only"
                                    label="1st and 2nd characters of National Insurance Number"
                                    errorsWrapperCss="isNIN-error-message"
                                    id={`national-insurance-number-${this.props.index}-1`}
                                    cssInput="text-center"
                                    placeholder="XX"
                                    disabled={this.state.useUniversalNINO || disableMaritalStatus}
                                    textCase="upper"
                                    regex={{ errorMessage: "Value must be 2 alphabetic values", value: Alphabetical2 }}
                                    value={NationalNumber[0]}
                                    textLength={2}
                                    onChange={(v) => {
                                        this.moveToNextInput(1, v);
                                        this.onNationalNumberChanges(0, v);
                                    }}
                                />
                            </div>
                            <div className="col-auto">
                                <TextBoxEditor
                                    cssWrapper="control-size-60 label-sr-only"
                                    label="3rd and 4th characters of National Insurance Number"
                                    errorsWrapperCss="isNIN-error-message"
                                    id={`national-insurance-number-${this.props.index}-2`}
                                    cssInput="text-center"
                                    placeholder="00"
                                    textLength={2}
                                    disabled={this.state.useUniversalNINO || disableMaritalStatus}
                                    value={NationalNumber[1]}
                                    regex={{ errorMessage: ValidatorContents.Numeric2, value: Numeric2 }}
                                    onChange={(v) => {
                                        this.moveToNextInput(2, v);
                                        this.onNationalNumberChanges(1, v);
                                    }}
                                />
                            </div>
                            <div className="col-auto">
                                <TextBoxEditor
                                    cssWrapper="control-size-60 label-sr-only"
                                    label="5th and 6th characters of National Insurance Number"
                                    errorsWrapperCss="isNIN-error-message"
                                    cssInput="text-center"
                                    placeholder="00"
                                    id={`national-insurance-number-${this.props.index}-3`}
                                    textLength={2}
                                    disabled={this.state.useUniversalNINO || disableMaritalStatus}
                                    value={NationalNumber[2]}
                                    validateOnTyping
                                    regex={{ errorMessage: ValidatorContents.Numeric2, value: Numeric2 }}
                                    onChange={(v) => {
                                        this.onNationalNumberChanges(2, v);
                                        this.moveToNextInput(3, v);
                                    }}
                                />
                            </div>
                            <div className="col-auto">
                                <TextBoxEditor
                                    cssWrapper="control-size-60 label-sr-only"
                                    label="7th and 8th characters of National Insurance Number"
                                    errorsWrapperCss="isNIN-error-message"
                                    cssInput="text-center"
                                    id={`national-insurance-number-${this.props.index}-4`}
                                    placeholder="00"
                                    textLength={2}
                                    disabled={this.state.useUniversalNINO || disableMaritalStatus}
                                    value={NationalNumber[3]}
                                    regex={{ errorMessage: ValidatorContents.Numeric2, value: Numeric2 }}
                                    onChange={(v) => {
                                        this.moveToNextInput(4, v);
                                        this.onNationalNumberChanges(3, v);
                                    }}
                                />
                            </div>
                            <div className="col-auto">
                                <TextBoxEditor
                                    cssWrapper="control-size-60 label-sr-only"
                                    label="9th and 10th characters of National Insurance Number"
                                    errorsWrapperCss="isNIN-error-message"
                                    cssInput="text-center"
                                    placeholder="X"
                                    textLength={1}
                                    id={`national-insurance-number-${this.props.index}-5`}
                                    disabled={this.state.useUniversalNINO || disableMaritalStatus}
                                    textCase="upper"
                                    value={NationalNumber[4]}
                                    onChange={(v) => {
                                        this.onNationalNumberChanges(4, v);
                                    }}
                                />
                            </div>
                        </div>
                        {!this.state.userInfo?.IsAdviser && (
                            <CheckboxEditor
                                onChange={(v) => {
                                    let _nationalNum = "";
                                    if (v) {
                                        this.setState({ NationalNumber: ["BB", "99", "99", "99", "A"] });
                                        _nationalNum = "BB999999A";
                                    } else {
                                        this.setState({ NationalNumber: [null, null, null, null, null] });
                                        _nationalNum = null;
                                    }
                                    let listIndex = this.props.data.CustomerTaxResidencyDetails?.findIndex(
                                        (ele) => ele.TaxReferenceType == TaxReferenceType.GbrNino
                                    );
                                    listIndex = listIndex == -1 ? 0 : listIndex;
                                    this.props.onCCMChange([
                                        {
                                            value: _nationalNum,
                                            path: `CustomerTaxResidencyDetails.${listIndex}.TaxReference`,
                                        },
                                        {
                                            value: TaxReferenceType.GbrNino,
                                            path: `CustomerTaxResidencyDetails.${listIndex}.TaxReferenceType`,
                                        },
                                        {
                                            value: true,
                                            path: `CustomerTaxResidencyDetails.${listIndex}.IsTaxResident`,
                                        },
                                    ]);
                                    this.setState({ useUniversalNINO: v });
                                }}
                                value={this.state.NationalNumber?.toString() == "BB,99,99,99,A"}
                                label="Universal National Insurance Number"
                                cssWrapper="control-size-60 square-checkbox "
                                disabled={disableMaritalStatus}
                            ></CheckboxEditor>
                        )}
                    </fieldset>
                </WizardLinter>
                <hr className="mb-20 mt-0" />
            </>
        );
    }
}
